import React, { useState } from 'react'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { MoreFilterContainer } from './MoreFilterContainer'
import { useObserver } from 'mobx-react-lite'
import Popover from '@material-ui/core/Popover'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import TabletViewMediaQuery from '@components/Utils/TabletViewMediaQuery'
import PopupComponent from '@components/std-components/Popup'

const useStyles = makeStyles(theme => ({
  moreButton: {
    display: 'flex',
    width: '100%',
    height: 40,
    alignItems: 'center',
    cursor: 'pointer'
  },
  paper: {
    height: '70%',
    width: '912px'
  }
}))

export const MoreFilterPopup = ({
  moreCount,
  filterValues,
  filterId,
  filterLabel,
  filterStore,
  handleFilterSelection,
  handleFilterExclusion,
  defaultEmptyText
}) => {
  return useObserver(function useHook() {
    const classes = useStyles()
    const { t } = useTranslation()
    const [anchorEl, setAnchorEl] = useState(null)

    const handleOpen = () => {
      const filterBodyNode = document.getElementById('filterBody')
      setAnchorEl(filterBodyNode)
    }

    const handleClose = () => {
      setAnchorEl(null)
      filterStore.resetFilterSearchKey()
    }

    const getMoreFilterContainer = isTablet => {
      return (
        <MoreFilterContainer
          filterId={filterId}
          filterValues={filterValues}
          filterLabel={filterLabel}
          filterStore={filterStore}
          setAnchorEl={setAnchorEl}
          defaultEmptyText={defaultEmptyText}
          handleFilterSelection={handleFilterSelection}
          handleFilterExclusion={handleFilterExclusion}
          isTablet={isTablet}
        />
      )
    }

    return (
      <>
        <div className={classes.moreButton} onClick={e => handleOpen()}>
          <Typography variant='buttonBlue'>{`+${moreCount} ${t(
            'common.label.more',
            'More'
          )}`}</Typography>
        </div>
        <TabletViewMediaQuery>
          {isTablet =>
            !isTablet ? (
              <Popover
                id={'simple-popover'}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                classes={{ paper: classes.paper }}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                {getMoreFilterContainer(isTablet)}
              </Popover>
            ) : (
              <PopupComponent
                open={Boolean(anchorEl)}
                onClose={handleClose}
                contentStyle={{ height: '690px', width: '660px', padding: 0 }}
                position='center center'
                arrow={false}
              >
                {getMoreFilterContainer(isTablet)}
              </PopupComponent>
            )
          }
        </TabletViewMediaQuery>
      </>
    )
  })
}
